module.exports = __webpack_public_path__ + "img/mobilenewsLogo7.5b78c7f2.png";